var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBusinessPackage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "business-package_svg__a",
    d: "M3.827.76c3.893-2.059 9.056.114 12.362 6.442 3.306 6.329-.39 16.477-.39 16.477s-10.403-2.694-13.71-9.021C-1.215 8.328-.065 2.82 3.828.76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "business-package_svg__c",
    d: "M22.897 4.246c2.193 3.835.233 9.108-5.928 12.674-6.16 3.565-16.379.238-16.379.238S2.868 6.597 9.028 3.03c6.16-3.565 11.676-2.62 13.87 1.215z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "business-package_svg__e",
    d: "M13.096.567c4.757 1.49 6.625 7.236 4.541 13.975-2.152 6.96-11.716 11.49-12.122 11.68a.497.497 0 01-.642-.201c-.228-.387-5.55-9.574-3.399-16.532C2.701 5.52 4.862 2.551 7.56 1.134 9.352.19 11.266-.004 13.096.567zm-2.077.681c-1.007 0-2.02.26-2.994.771-2.46 1.292-4.448 4.05-5.596 7.765C.652 15.53 4.514 23.262 5.51 25.108c1.863-.954 9.397-5.119 11.173-10.86 1.91-6.18.313-11.412-3.885-12.726a5.93 5.93 0 00-1.778-.274z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "business-package_svg__g",
    d: "M8.861.382l66.858 19.515a3 3 0 012.042 3.711L73.321 39 .703 17.804 5.138 2.431A3.007 3.007 0 018.861.382z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "business-package_svg__i",
    d: "M5.459.022l7.644 2.231-5.269 18.265L.19 18.287z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "business-package_svg__k",
    d: "M41.346 47.614a.5.5 0 01.196.68c-.171.31-.364.612-.573.897a.502.502 0 01-.806-.594c.186-.253.354-.516.504-.787a.497.497 0 01.679-.196zm1.214-3.404l.001.123c0 .313-.018.627-.053.936a.501.501 0 01-.994-.113 7.28 7.28 0 00.047-.822l-.001-.113a.5.5 0 01.494-.505c.312-.032.503.216.506.493zm-1.152-4.056c.182.304.345.622.486.947a.502.502 0 01-.459.699.498.498 0 01-.459-.301 7.072 7.072 0 00-.426-.83.5.5 0 11.858-.514zm-13.092-1.147a.499.499 0 01-.357.61 8.1 8.1 0 01-1.045.205.5.5 0 11-.127-.993c.308-.038.615-.1.918-.178a.494.494 0 01.611.356zm-5.187-.683c.288.122.583.224.883.308a.498.498 0 01-.133.98.522.522 0 01-.135-.018 8.197 8.197 0 01-1.003-.349.499.499 0 11.388-.921zm15.257-1.103c.311.172.612.367.895.577a.499.499 0 11-.597.801 7.408 7.408 0 00-.784-.505.5.5 0 01.486-.874zm-6.532-.065a.5.5 0 01-.252.66 6.815 6.815 0 00-.825.438.498.498 0 01-.688-.164.501.501 0 01.163-.689c.3-.184.616-.352.941-.498a.497.497 0 01.661.253zm-11.629-1.111c.189.252.392.488.607.71a.5.5 0 11-.716.697 8.053 8.053 0 01-.691-.81.499.499 0 11.8-.598zm14.241.16c.299 0 .598.017.894.05a.5.5 0 01-.056.997c-.019 0-.038 0-.057-.003a6.996 6.996 0 00-.781-.044l-.151.003c-.303.028-.504-.215-.51-.491a.502.502 0 01.491-.51l.17-.002zM18.85 32.614c.037.308.094.614.171.918a.499.499 0 11-.968.247 8.078 8.078 0 01-.196-1.047.497.497 0 01.437-.554.493.493 0 01.556.436zm.25-4.318c.255.107.374.4.266.655a7.197 7.197 0 00-.306.883.501.501 0 01-.615.347.498.498 0 01-.349-.614c.095-.343.212-.68.35-1.006a.497.497 0 01.654-.265zm2.639-2.956a.5.5 0 01-.099.7c-.252.19-.488.393-.709.61a.498.498 0 01-.707-.008.5.5 0 01.008-.707c.253-.247.524-.48.806-.694a.5.5 0 01.701.1zm2.54-2.985c.243.13.336.433.206.677a8.236 8.236 0 01-.562.904.498.498 0 01-.698.116.5.5 0 01-.115-.698 7.25 7.25 0 00.492-.793.499.499 0 01.677-.206zm.649-3.91a.52.52 0 01.516.485l.004.242c0 .274-.014.55-.041.822a.5.5 0 01-.498.45c-.016 0-.033 0-.05-.002a.5.5 0 01-.448-.547c.025-.24.037-.482.037-.723l-.003-.21a.501.501 0 01.483-.517zm-.693-3.55c.187.302.355.619.499.943a.498.498 0 11-.912.407 7.256 7.256 0 00-.437-.825.5.5 0 11.85-.525zM11.1 13.877a.5.5 0 01-.364.606 8.123 8.123 0 01-1.048.19c-.019.002-.038.004-.057.004a.5.5 0 01-.056-.997c.309-.035.615-.09.918-.166a.499.499 0 01.607.364zm-5.175-.755c.285.126.578.232.877.319a.5.5 0 11-.28.96 7.885 7.885 0 01-1.001-.364.501.501 0 01.404-.915zm15.246-1.12c.311.166.615.355.904.564a.5.5 0 01-.584.811 7.015 7.015 0 00-.792-.494.5.5 0 11.472-.881zm-6.53.03a.501.501 0 01-.245.665 6.857 6.857 0 00-.817.447.497.497 0 01-.691-.153.5.5 0 01.154-.69c.302-.194.617-.366.935-.512a.5.5 0 01.664.244zM3.053 10.8c.186.256.386.496.598.72a.5.5 0 01-.727.688 8.195 8.195 0 01-.68-.82.5.5 0 11.809-.588zm14.307.243c.254 0 .514.014.772.038a.499.499 0 01-.048.997c-.016 0-.032 0-.049-.002-.242-.024-.486-.024-.728-.033-.07 0-.138.002-.205.005-.28-.018-.507-.207-.516-.485a.499.499 0 01.483-.516c.097-.002.195-.005.29-.004h.001zM1.697 7.357c.035.308.091.616.168.917a.501.501 0 01-.97.245 7.916 7.916 0 01-.192-1.048.5.5 0 11.994-.114zm.334-4.3c.251.118.36.414.245.666-.131.28-.242.574-.331.869a.501.501 0 01-.957-.291c.103-.34.231-.675.379-.998a.502.502 0 01.664-.245zm2.76-2.84a.5.5 0 01-.128.696c-.261.18-.506.373-.734.577a.496.496 0 01-.706-.038.498.498 0 01.038-.705c.263-.236.543-.458.835-.658.229-.157.54-.1.695.129z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "business-package_svg__m",
    d: "M66.88 0v33a4 4 0 01-4 4H4.797c-2.201 0-4-1.8-4-4V0H66.88z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "business-package_svg__o",
    d: "M2.507.994l2.646 7-2.319.888L.188 1.881z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "business-package_svg__q",
    d: "M4.598.032l11.031 13.667-4.529 3.7L.07 3.731z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "business-package_svg__s",
    d: "M5.932.041l.561 17.596-5.83.189L.101.229z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "business-package_svg__u",
    d: "M2.399.031l2.807 4.863-1.611.941L.788.972z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "business-package_svg__w",
    d: "M2.03.116a1.899 1.899 0 011.879 1.92 1.903 1.903 0 01-1.91 1.892A1.901 1.901 0 01.122 2.006 1.899 1.899 0 012.03.115z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "business-package_svg__y",
    d: "M.751.789L4.54.831l-.125 11.434-3.789-.041z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "business-package_svg__A",
    d: "M.88 0h7.917v37H.88z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "business-package_svg__C",
    d: "M2.38 0a.5.5 0 010 1h-1a.5.5 0 010-1h1zm4 0a.5.5 0 010 1h-1a.5.5 0 010-1h1zm4 0a.5.5 0 010 1h-1a.5.5 0 010-1h1zm4 0a.5.5 0 010 1h-1a.5.5 0 010-1h1zm4 0a.5.5 0 010 1h-1a.5.5 0 010-1h1zm4 0a.5.5 0 010 1h-1a.5.5 0 010-1h1zm4 0a.5.5 0 010 1h-1a.5.5 0 010-1h1zm4 0a.5.5 0 010 1h-1a.5.5 0 010-1h1zm4 0a.5.5 0 010 1h-1a.5.5 0 010-1h1zm4 0a.5.5 0 010 1h-1a.5.5 0 010-1h1zm4 0a.5.5 0 010 1h-1a.5.5 0 010-1h1zm4 0a.5.5 0 010 1h-1a.5.5 0 010-1h1zm4 0a.5.5 0 010 1h-1a.5.5 0 010-1h1zm4 0a.5.5 0 010 1h-1a.5.5 0 010-1h1zm4 0a.5.5 0 010 1h-1a.5.5 0 010-1h1zm4 0a.5.5 0 010 1h-1a.5.5 0 010-1h1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "business-package_svg__E",
    d: "M54.88 2c0 1.093-11.83 1.981-26.52 2h-.48c-14.912 0-27-.896-27-2C.88.908 12.709.02 27.4 0h.48c14.912 0 27 .896 27 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "business-package_svg__G",
    d: "M2.38 0l.144.007A1.501 1.501 0 112.38 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "business-package_svg__I",
    d: "M2.38 0l.144.007A1.501 1.501 0 112.38 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(66 4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "business-package_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#business-package_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C593E5",
    d: "M-4.848-4.992h27.411v33.67H-4.848z",
    mask: "url(#business-package_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76 9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "business-package_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#business-package_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B372D8",
    d: "M-4.41-4.195h33.175v27.763H-4.41z",
    mask: "url(#business-package_svg__d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(73 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "business-package_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#business-package_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E1C9F1",
    d: "M-4.037-4.753h27.519v36.022H-4.037z",
    mask: "url(#business-package_svg__f)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37 15)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "business-package_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#business-package_svg__g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F0DCF2",
    d: "M-4.297-4.738h87.176V44H-4.297z",
    mask: "url(#business-package_svg__h)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70 24)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "business-package_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#business-package_svg__i"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C593E5",
    d: "M-4.81-4.978h22.913v30.496H-4.81z",
    mask: "url(#business-package_svg__j)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26 13)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "business-package_svg__l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#business-package_svg__k"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B372D8",
    d: "M-4.3-4.999h51.861v59.393H-4.3z",
    mask: "url(#business-package_svg__l)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39 60)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "business-package_svg__n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#business-package_svg__m"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F0DCF2",
    d: "M-4.203-5H71.88v47H-4.203z",
    mask: "url(#business-package_svg__n)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44 54)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "business-package_svg__p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#business-package_svg__o"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B372D8",
    d: "M-4.812-4.006h14.965v17.888H-4.812z",
    mask: "url(#business-package_svg__p)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 25)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "business-package_svg__r",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#business-package_svg__q"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ED4E4D",
    d: "M-4.93-4.968h25.559v27.367H-4.93z",
    mask: "url(#business-package_svg__r)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 54)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "business-package_svg__t",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#business-package_svg__s"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F5C400",
    d: "M-4.899-4.959h16.392v27.785H-4.899z",
    mask: "url(#business-package_svg__t)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 12)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "business-package_svg__v",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#business-package_svg__u"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B372D8",
    d: "M-4.212-4.969h14.418v15.804H-4.212z",
    mask: "url(#business-package_svg__v)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 44)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "business-package_svg__x",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#business-package_svg__w"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#5FCEF5",
    d: "M-4.879-4.885H8.909V8.928H-4.879z",
    mask: "url(#business-package_svg__x)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54 32)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "business-package_svg__z",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#business-package_svg__y"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#5FCEF5",
    d: "M-4.374-4.211H9.54v21.476H-4.374z",
    mask: "url(#business-package_svg__z)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(68 60)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "business-package_svg__B",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#business-package_svg__A"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C593E5",
    d: "M-4.12-5h17.917v47H-4.12z",
    mask: "url(#business-package_svg__B)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41 68)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "business-package_svg__D",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#business-package_svg__C"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B372D8",
    d: "M-4.12-5h72V6h-72z",
    mask: "url(#business-package_svg__D)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44 114)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "business-package_svg__F",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#business-package_svg__E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ECE9F3",
    d: "M-4.12-5h64V9h-64z",
    mask: "url(#business-package_svg__F)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27 45)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "business-package_svg__H",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#business-package_svg__G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B372D8",
    d: "M-4.12-5h13V8h-13z",
    mask: "url(#business-package_svg__H)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31 18)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "business-package_svg__J",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#business-package_svg__I"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ED4E4D",
    d: "M-4.12-5h13V8h-13z",
    mask: "url(#business-package_svg__J)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h120v120H0z"
  }))));
}

export default __webpack_public_path__ + "media/business-package.57485ee3.svg";
export { SvgBusinessPackage as ReactComponent };